import styled from 'styled-components';
import NawyExclusiveIcon from '../../../../new-components/svg-icons/NawyExclusiveIcon';
import Checkbox from './Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { setNawyExclusive } from '../../../../redux/slices/offersSlice';

const NawyExclusiveFilter = () => {
  const isNawyExclusive = useSelector(
    (state: any) => state.offers.isNawyExclusive
  );

  const dispatch = useDispatch();

  const handleFilterClick = () => {
    dispatch(setNawyExclusive());
  };

  return (
    <Container>
      <Checkbox checked={isNawyExclusive} onClick={handleFilterClick} />

      <NawyExclusiveIcon />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-inline-end: 8px;
  border-inline-end: 1px solid #d1d4d9;
  margin-inline-end: 4px;
  height: 40px;
`;

export default NawyExclusiveFilter;
